import Swiper from "swiper";
import {Pagination} from "swiper/modules";

export const sliderHomeTestimony = (slider: HTMLElement) => {
    new Swiper(slider, {
        modules: [Pagination],
        pagination: {
            el: slider.querySelector('.swiper-pagination') as HTMLElement,
            clickable: true,
        },
        slidesPerView: 1.1,
        spaceBetween: 30,
        centeredSlides: true,
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            450: {
                slidesPerView: 1.5,
                spaceBetween: 30,
            }
        }
    })
}
